import React from 'react';
import { Icon, IconComponent } from './icon';
import src from 'grpn-mx-mixer/dist/images/icons/caret-left.svg';

export const IconCaretLeft: IconComponent = props => <Icon {...props} src={src} />;
